module.exports = __webpack_public_path__ + "static/eluemuno-52cea2e166650b97203d5e6fe53070af.png";